@import '~style-sheet-helpers/core.less';

.section {
  line-height: 22px;
  padding-bottom: 8px;

  .section-item {
    font-size: 14px;
    height: 100%;
    line-height: 20px;
    padding: 4px 0 8px;
    width: fit-content;

    &:first-of-type {
      padding-top: 0;
    }
  }

  .section-text {
    font-size: 16px;
    line-height: 22px;
    padding-top: 0;
  }

  .cost-summary-section {
    .radio-item {
      line-height: 1;
      padding: 4px 0 8px 20px;
    }
  }
}

.checkbox-row,
.radio-row {
  cursor: pointer;
  label {
    font-size: 14px;
  }

  &:last-child {
    padding-bottom: 0;
  }
}
